import React, { useEffect, useState } from "react";
import { Tabs, Table, Button, Search, IconDownload, Select, DatePicker, TextBox, IconPlus, InlineNotification, FilePicker, AlertModal, ConfirmationModal, Modal, Scrollbar } from "@veneer/core";
import ConnectAPI from '../../../services/api';
import Swal from 'sweetalert2';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Col, Row } from "react-bootstrap";
import XLSX from "xlsx";
import $ from 'jquery';
import ModifyDateVA from './ModifyDateVA';
import { downloadFile } from "../../../services/FileDownloader/FileDownloader";

const VolumeAcceleration = ( props ) => {
    //Variables
    const [activeTabIndex, setactiveTabIndex] = useState(0);
    const [t] = useTranslation();
    const connectApi = new ConnectAPI();
    const [dataVA, setDataVA] = useState([]);
    const [dataRVA, setDataRVA] = useState([]);
    const [loadingData, setLoadingData] = useState(false);
    const [dateSelected, setDateSelected] = useState();
    const [dateSelectedLast, setDateSelectedLast] = useState();
    const [datesView, setDatesView] = useState([]);
    const [dateLastPublication, setdateLastPublication] = useState();
    const [channelView, setChannelView] = useState([]);
    const [channel, setChannel] = useState();
    const [endUserList, setEndUserList] = useState([]);

    //Metodos
    const selectTab = () => (index) => {
        setactiveTabIndex(index);
    };
    useEffect(() => {
        //validate location
        let currentUser = JSON.parse(localStorage.getItem("currentUser"));
        let validate=false;
        currentUser.urls.forEach(ur=>{
            if (ur==window.location.pathname){
                validate=true;
            }
        });
        if (validate==false){
            const { history } = props;
            history.push({
                pathname: '/' 
            });
        }
        //end validate
        const fetchChannels = async () => {
            connectApi.get('api/Channels', '', dataResponseChannel)
            .catch((error) => {
                setLoadingData(false);
                Swal.fire(
                    "Error " + error.response,
                    error.response,
                    "error"
                );
            });
        };
        const dataResponseChannel = (status, data) => {
            const items = data.map((item) => {
                if (item.type != "Inactive"){
                    return{
                        value: item.idCustomer,
                        label: item.name,
                    };
                }
            });
            let channels = items.filter(x => x)
            setChannelView(channels);
        };
        const fetchData = async () => {
            connectApi.get(
                "api/Channels/VolumeAcceleration",
                {
                    params: {
                        date: dateSelected,
                        dateLast: dateSelectedLast
                    },
                },
                dataResponseLoad
            ).catch((error) => {
                setLoadingData(false);
                Swal.fire(
                    "Error " + error.response,
                    error.response,
                    "error"
                );
            });
            setLoadingData(true);
        };
        let option = {
            style: 'percent',
            maximumFractionDigits: 2
        };
        const dataResponseLoad = (status, data) => {
            const items = data['reportDates'].map((item) => {
                return {
                    value: moment(item.date).format("YYYY-MM-DDTHH:mm:ss"),
                    label: moment(item.date).format("MMM") + " " + moment(item.date).format("YYYY"),
                };
            });
            // data['rangeDates']
            data['dataVA'].forEach(x => {
                x.startDate = moment(x.startDate).format("MMM/YYYY");
                x.endDate = moment(x.endDate).format("MMM/YYYY");
                x.targetTPI = new Intl.NumberFormat().format(x.targetTPI);
                x.addBonus = new Intl.NumberFormat('en-US', option).format(x.addBonus);
                x.addCreditNote = new Intl.NumberFormat('en-US', option).format(x.addCreditNote); 
                //x.addCreditNote = `${(Math.floor(x.addCreditNote*100))} %`;
                
            });
            data['dataRVA'].forEach(x => {
                x.monthYear = moment(x.monthYear).format("MMM/YYYY");
                x.bonus = new Intl.NumberFormat("en", { maximumFractionDigits: 2 }).format(x.bonus);
                x.creditNote = new Intl.NumberFormat("en", {maximumFractionDigits: 2}).format(x.creditNote);
                x.suppliesSpent = new Intl.NumberFormat("en", {maximumFractionDigits: 2}).format(x.suppliesSpent);
                x.suppliesSpentChannel = new Intl.NumberFormat("en", {maximumFractionDigits: 2}).format(x.suppliesSpentChannel);
                x.allTPI = new Intl.NumberFormat().format(x.allTPI);
                x.targetTPI = new Intl.NumberFormat().format(x.targetTPI);
                x.addBonus = new Intl.NumberFormat('en-US', option).format(x.addBonus);
                x.addCreditNote = new Intl.NumberFormat('en-US', option).format(x.addCreditNote);
            });
            if( !dateSelected ){
                setDateSelected( data['rangeDates'][2] === undefined ? null : data['rangeDates'][2] );
                setdateLastPublication( data['rangeDates'][2] === undefined ? null : data['rangeDates'][2] );
                setDateSelectedLast( data['rangeDates'][2] === undefined ? null : data['rangeDates'][2] );
            }
            setDatesView(items);
            setDataVA(data['dataVA'] === undefined ? [] : data['dataVA']);
            setDataRVA(data['dataRVA'] === undefined ? [] : data['dataRVA']);
            setLoadingData(false)
        };
        fetchChannels();
        fetchData();
    },[dateSelected,dateSelectedLast] );
    function descendingComparator(a, b, orderBy) {
        const aSort = a[orderBy] && a[orderBy].toString().toUpperCase();
        const bSort = b[orderBy] && b[orderBy].toString().toUpperCase();
        if ( orderBy === "targetTPI" || orderBy === "allTPI" || orderBy === "idPress" ){
            let bS = bSort + "";
            let aS = aSort + "";
            if (parseInt(bS.replaceAll(',','')) < parseInt(aS.replaceAll(',',''))) 
                return -1;
            if (parseInt(bS.replaceAll(',','')) > parseInt(aS.replaceAll(',','')))
                return 1;
        } if( orderBy === "channel" || orderBy === "endUser" || orderBy === "customerName" || orderBy === "endUserName"  ){
            if (bSort < aSort)
                return -1;
            if (bSort > aSort)
                return 1;
        } else if( orderBy === "startDate" || orderBy === "endDate" || orderBy === "monthYear" ){
            if (Date.parse(bSort) < Date.parse(aSort))
                return -1;
            if (Date.parse(bSort) > Date.parse(aSort))
                return 1;
        }else{
            if (parseFloat(bSort) < parseFloat(aSort)) 
                return -1;
            if (parseFloat(bSort) > parseFloat(aSort))
                return 1;
        }
        return 0;
    }
    function filterSort(array, filters, orderBy, orderType) {
        let arrayFiltered = array;
        Object.keys(filters).forEach((value) => {
            const filterValue = filters[value];
            const filter = typeof filterValue === "object" ? filterValue[0] : filterValue;
            if (filter)
                arrayFiltered = arrayFiltered.filter((a) => {
                const aUpper = a[value] && a[value].toString().toUpperCase();
                const filterUpper = filter && filter.toString().toUpperCase();
                return aUpper.indexOf(filterUpper) > -1;
                });
            });
        return arrayFiltered.sort((a, b) => {
            const value = (orderType === 'descending')
            ? descendingComparator(a, b, orderBy) : -descendingComparator(a, b, orderBy);
            return value;
        });
    }
    const fetchEndUsers = (channel) => {
        connectApi.get("api/Channels/endUsers",{
            params:{
                customerId: channel,
                status: "Active",
            }
        },EndUserListData).catch((error) => {
            Swal.fire(
                "Error " + error?.response,
                error?.response,
                "error"
            );
        });
    };
    const EndUserListData = (status, data) => {
        const items = data.map((item) => {
            return{
                value: item.idEndUser,
                label: item.endUserName,
            };
        });
        setEndUserList(items);
    };

    //Vistas
    const RenderVolumeAcceleration = () => {
        const [orderBy, setOrderBy] = useState("startDate");
        const [orderType, setOrderType] = useState("descending");
        const [endUserFilter, setEndUserFilter] = useState("");
        const [channelFilter, setChannelFilter] = useState("");
        const [currentPage, setCurrentPage] = useState(1);
        const pageSize = 25;
        const [order, setOrder] = useState([
            'channel',
            'endUser',
            'targetTPI',
            'addBonus',
            'addCreditNote',
            'startDate',
            'endDate'
        ]);
        const handlePageChange = (page) => setCurrentPage(page);
        const [showModal, setShowModal] = useState(false);
        const [volumeA, setVolumeA] = useState([]);
        const [endDate, setEndDate] = useState([]);
        const filteredData = filterSort(
            dataVA, {
                channel: channelFilter,
                endUser: endUserFilter,
            },
            orderBy,
            orderType
        );
        let pagedData = filteredData.slice(
          (currentPage - 1) * pageSize,
          (currentPage - 1) * pageSize + pageSize
        );
        const handleSort = (_, { id, type }) => {
          setOrderBy(id);
          setOrderType(type);
        };
        const handleChange = (name) => (event) => {
            setDateSelected(event.value);
            setCurrentPage(1);
        };
        function setModalParameters(e){
            var channel = $(e.target).closest('tr').children().eq(0).text();
            var endUserName = $(e.target).closest('tr').children().eq(1).text();
            var targetTPI = $(e.target).closest('tr').children().eq(2).text();
            if( channel !== 'Channel ' & endUserName !== 'End user' & targetTPI !== '' ){
                let vaItem = dataVA.find(va => va.channel === channel & va.endUser === endUserName & va.targetTPI === targetTPI );
                setVolumeA(vaItem);
                setEndDate(vaItem.endDate)
                setShowModal(true);
            }
            
        };
        return (
            <div>
                <Row>
                    <Col 
                        style={{
                            position: "absolute",
                            marginTop: "5px",
                        }}
                    >
                        <div
                            style={{
                                width: '150px',
                            }}
                        >
                        <Select
                            name="datesSearsh"
                            onChange={handleChange()}
                            options={datesView}
                            placeholder= {t('date')}
                            value={[dateSelected]}
                            clearIcon={false}
                        />
                        </div>
                    </Col>
                </Row>
                <div>
                    <Table
                        onClick={setModalParameters}
                        columns = {[
                            {
                                id: 'channel',
                                label: t("channel"),
                                filter: (
                                    <Search
                                        id="channel-filter"
                                        value={channelFilter}
                                        onChange={(val) => {
                                            setChannelFilter(val);
                                            setCurrentPage(1);
                                        }}
                                    />
                                )
                            },
                            {
                                id: 'endUser',
                                label: t("endUser"),
                                filter: (
                                    <Search
                                        id="name-filter"
                                        value={endUserFilter}
                                        onChange={(val) => {
                                            setEndUserFilter(val);
                                            setCurrentPage(1);
                                        }}
                                    />
                                )
                            },
                            {
                                id: 'targetTPI',
                                label: t("targetTPI")
                            },
                            {
                                id: 'addBonus',
                                label: t("addBonus")
                            },
                            {
                                id: 'addCreditNote',
                                label: t("addCreditNote")
                            },
                            {
                                id: 'startDate',
                                label: t("specialcondition.startdate")
                            },
                            {
                                id: 'endDate',
                                label: t("specialcondition.enddate")
                            },
                        ]}
                        showFilters
                        columnReorder
                        data={pagedData}
                        loading={loadingData}
                        onSort={handleSort}
                        onColumnReorder={(reOrder) => setOrder(reOrder)}
                        preferences={{
                            defaultOrder: order,
                            sortBy: {
                                id: orderBy,
                                type: orderType,
                            },
                            order: order
                        }}
                        pagination={{
                            currentPage,
                            onPageChange: handlePageChange,
                            pageSize,
                            totalItems: filteredData.length,
                        }}
                    />
                    <div style={{ textAlign: "left" }}>
                        <Button
                            onClick={()=>{
                                setTimeout(() => {
                                const dataXlsx = filteredData.map((item) => { return item; });
                                const ws = XLSX.utils.json_to_sheet(dataXlsx, { header: order });
                                const wb = XLSX.utils.book_new();
                                const date = moment(new Date()).format('YYYYMMDDHHmm');
                                const filename = 'VolumeAcceleration-' + date + '.xlsx';
                                const ws_name = "VolumeAcceleration";
                                XLSX.utils.book_append_sheet(wb, ws, ws_name);
                                XLSX.writeFile(wb, filename);
                                }, 750);
                            }}
                            disabled={filteredData.length === 0}
                            leadingIcon={<IconDownload />}
                            title={t('download data')}
                        >
                            {t('download')}
                        </Button>
                    </div>
                </div>
                <ModifyDateVA
                    showModal={showModal}
                    setShowModal={setShowModal}
                    item={volumeA}
                    endDate={endDate}
                    dateLastP={dateLastPublication}
                    fetchData={useEffect}
                />
            </div>
        );
    }
    const RenderResultVA = () => {
        const [orderBy, setOrderBy] = useState("startDate");
        const [orderType, setOrderType] = useState("descending");
        const [endUserNameFilter, setEndUserNameFilter] = useState("");
        const [customerNameFilter, setCustomerNameFilter] = useState("");
        const [currentPage, setCurrentPage] = useState(1);
        const pageSize = 25;
        const [order, setOrder] = useState([
            'customerName',
            'endUserName',
            'idPress',
            'monthYear',
            'bonus',
            'creditNote',
            'suppliesSpent',
            'suppliesSpentChannel',
            'allTPI',
            'targetTPI',
            'addBonus',
            'addCreditNote'
        ]);
        const handlePageChange = (page) => setCurrentPage(page);
        const filteredData = filterSort(
            dataRVA, {
                customerName: customerNameFilter,
                endUserName: endUserNameFilter,
            },
            orderBy,
            orderType
        );
        let pagedData = filteredData.slice(
            (currentPage - 1) * pageSize,
            (currentPage - 1) * pageSize + pageSize
        );
        const handleSort = (_, { id, type }) => {
            setOrderBy(id);
            setOrderType(type);
        };
        const handleChangeDateStart = (name) => (event) => {
            setDateSelected(event.value);
            setCurrentPage(1);
        };
        const handleChangeDateEnd = (name) => (event) => {
            setDateSelectedLast(event.value);
            setCurrentPage(1);
        };
        return (
            <div>
                <Row>
                    <Col 
                        style={{
                            position: "absolute",
                            marginTop: "5px",
                        }}
                    >
                        <div
                            style={{
                                width: '150px',
                            }}
                        >
                            <label>{t("specialcondition.startdate")}</label>
                            <Select
                                name="datesSearshStart"
                                onChange={handleChangeDateStart()}
                                options={datesView}
                                placeholder= {t('date')}
                                value={[dateSelected]}
                                clearIcon={false}
                            />
                            <div style={{ width: '150px', marginTop: '-60px', marginLeft: '152px' }}>
                            <label>{t("specialcondition.enddate")}</label>
                            <Select
                                name="datesSearshEnd"
                                onChange={handleChangeDateEnd()}
                                options={datesView}
                                placeholder= {t('date')}
                                value={[dateSelectedLast]}
                                clearIcon={false}
                            />
                            </div>
                        </div>
                    </Col>
                </Row>
                <div style={{ marginTop: "20px", }}>
                    <Table
                        columns = {[
                            {
                                id: 'customerName',
                                label: t("channel"),
                                filter: (
                                    <Search
                                        id="customerName-filter"
                                        value={customerNameFilter}
                                        onChange={(val) => {
                                            setCustomerNameFilter(val);
                                            setCurrentPage(1);
                                        }}
                                    />
                                )
                            },
                            {
                                id: 'endUserName',
                                label: t("endUser"),
                                filter: (
                                    <Search
                                        id="endUserName-filter"
                                        value={endUserNameFilter}
                                        onChange={(val) => {
                                            setEndUserNameFilter(val);
                                            setCurrentPage(1);
                                        }}
                                    />
                                )
                            },
                            {
                                id: 'idPress',
                                label: t("pressid")
                            },
                            {
                                id: 'monthYear',
                                label: t("monthYear")
                            },
                            {
                                id: 'bonus',
                                label: t("bonus")
                            },
                            {
                                id: 'creditNote',
                                label: t("creditNote")
                            },
                            {
                                id: 'suppliesSpent',
                                label: t("suppliesSpent")
                            },
                            {
                                id: 'suppliesSpentChannel',
                                label: t("suppliesSpentChannel")
                            },
                            {
                                id: 'allTPI',
                                label: t("allTPI")
                            },
                            {
                                id: 'targetTPI',
                                label: t("targetTPI")
                            },
                            {
                                id: 'addBonus',
                                label: t("addBonus")
                            },
                            {
                                id: 'addCreditNote',
                                label: t("addCreditNote")
                            },
                        ]}
                        showFilters
                        columnReorder
                        data={pagedData}
                        loading={loadingData}
                        onSort={handleSort}
                        onColumnReorder={(reOrder) => setOrder(reOrder)}
                        preferences={{
                            defaultOrder: order,
                            sortBy: {
                                id: orderBy,
                                type: orderType,
                            },
                            order: order
                        }}
                        pagination={{
                            currentPage,
                            onPageChange: handlePageChange,
                            pageSize,
                            totalItems: filteredData.length,
                        }}
                    />
                    <div style={{ textAlign: "left" }}>
                        <Button
                            onClick={()=>{
                                setTimeout(() => {
                                const dataXlsx = filteredData.map((item) => { return item; });
                                const ws = XLSX.utils.json_to_sheet(dataXlsx, { header: order });
                                const wb = XLSX.utils.book_new();
                                const date = moment(new Date()).format('YYYYMMDDHHmm');
                                const filename = 'VolumeAcceleration-' + date + '.xlsx';
                                const ws_name = "VolumeAcceleration";
                                XLSX.utils.book_append_sheet(wb, ws, ws_name);
                                XLSX.writeFile(wb, filename);
                                }, 750);
                            }}
                            disabled={filteredData.length === 0}
                            leadingIcon={<IconDownload />}
                            title={t('download data')}
                        >
                            {t('download')}
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
    const AddVolumAcelerationOptions = () => {
        const [idEndUser, setIdEndUser] = useState();
        const [targetTPI, setTargetTPI] = useState();
        const [addBonus, setAddBonus] = useState();
        const [addCreditNote, setAddCreditNote] = useState();
        const [startDate, setStartDate] = useState();
        const [endDate, setEndDate] = useState();
        const [buttonFlag, setButtonFlag] = useState(true);
        const [showNotification, setShowNotification] = useState(false);
        const [notificationDetails, setNotificationDetails] = useState({ title: '', type: '', description: '' });
        const [file, setFile]=useState(null);
        const [submit, setSubmit] = useState(false);
        const [confirButton, setConfirButton] = useState(false);
        const [dataDuplicate, setDataDuplicate] = useState(false);
        const [dataContent, setDataContent] = useState("");

        const handleOnDateChange = (newDates) => {
            const {
                startDate: newStartDate,
                endDate: newEndDate,
            } = newDates;
            setStartDate(newStartDate);
            setEndDate(newEndDate);
            newEndDate?setButtonFlag(false):setButtonFlag(true);
        };
        const validFormData = () => {
            let flag = false;
            if( addBonus <= 0 | addCreditNote <= 0 | targetTPI <= 0 ){
                setNotificationDetails({
                    title: t("notifyWrongValues"),
                    type: 'negative',
                    description: t("notifyNegativeOrCero") + ": " + t("addBonus") + ", " + t("addCreditNote") + ", " + t("targetTPI")
                });
                setShowNotification(true);
            } else if ( targetTPI <= 0 | targetTPI % 1 !== 0 ){
                setNotificationDetails({
                    title: t("notifyWrongValues"),
                    type: 'negative',
                    description: t("notifyIntergerValues") + ": " + t("targetTPI")
                });
                setShowNotification(true);
            } else if( !/[0-9]+([.][0-9]+)/.test(addBonus) | !/[0-9]+([.][0-9]+)/.test(addCreditNote) ){
                setNotificationDetails({
                    title: t("notifyWrongValues"),
                    type: 'negative',
                    description: t("notifyDecimalValues") + ": " + t("addBonus") + ", " + t("addCreditNote")
                });
                setShowNotification(true);
            } else if ( new Date(startDate) <= new Date(dateLastPublication) ){
                setNotificationDetails({
                    title: t("notifyWrongDate"),
                    type: 'negative',
                    description: t("notifyDatesValue")
                });
                setShowNotification(true);
            } else
                uploadOneDate();
        }
        const uploadOneDate = () => {
            let data = new FormData();
            data.append("Action","OneDate");
            data.append("idEndUser", idEndUser);
            data.append("TargetTPI", targetTPI);
            data.append("AddBonus", addBonus);
            data.append("AddCreditNote", addCreditNote);
            data.append("StartDate", moment(new Date( new Date(startDate).getFullYear(), new Date(startDate).getMonth(), 1 )).format("YYYY-MM-DD"));
            data.append("EndDate", moment(new Date( new Date(endDate).getFullYear(), new Date(endDate).getMonth()+1, 0 )).format("YYYY-MM-DD"));
            const handleUploadResponse = (status, response) => {
                if (response === 'allGood') {
                    setNotificationDetails({
                        title: t("notifyAllCorrect"),
                        type: 'positive',
                        description: ''
                    });
                    setIdEndUser('');
                    setTargetTPI(0);
                    setAddBonus(0);
                    setAddCreditNote(0);
                    setStartDate('');
                    setEndDate('');
                    setChannelView([]);
                    setEndUserList([]);
                } else 
                    setNotificationDetails({
                        title: t("notifyWrognSQL"),
                        type: 'negative',
                        description: t("notifySQLError")
                    });
                setShowNotification(true);
            }
            connectApi.post(
                "api/Channels/uploadVAData",
                data,
                handleUploadResponse
            ).catch((error) => {
                Swal.fire(
                    "Error " + error.response.status,
                    error.response.data, "error"
                );
            });
        }
        function handleChange(event) {
            setFile(event.target.files[0]);
        }
        function submitFile( condition ){
            setSubmit(true);
            let data = new FormData();
            data.append("Action","FileDate");
            data.append("Condition", condition);
            data.append("LastPublication", moment(dateLastPublication).format("YYYY-MM-DD"));
            data.append("file", file);
            connectApi.post(
                "api/Channels/uploadVAData",
                data,
                handleReloadData
            ).catch((error) => {
                if (error?.response?.status==502) {
                    setConfirButton(true);
                } else if (error?.response?.status==503){
                    setDataContent(error?.response?.data);
                    setDataDuplicate(true);
                } else {
                Swal.fire(
                        "Error " ,
                        error?.response?.data,
                        "error"
                    ); 
                }
                setSubmit(false);
            });
        }
        const handleReloadData = (status,data) => {
            if (status==200) {
                setNotificationDetails({
                    title: t("notifyAllCorrect"),
                    type: 'positive',
                    description: ''
                });
            } else {
                Swal.fire(
                    "Error " + data.status,
                    data.data,
                    "error"
                );
                setNotificationDetails({
                    title: t("notifyWrognSQL"),
                    type: 'negative',
                    description: t("notifySQLError")
                });
            }
            setSubmit(false);
            setShowNotification(true);
        }

        return(
            <div>
                {confirButton? (
                    <ConfirmationModal
                        id="confirmation-modal" 
                        onConfirm={() => {setConfirButton(false);submitFile("approved");}}
                        onClose={() => {setConfirButton(false)}}
                        show={confirButton}
                        title={t("requestConfirmation")}
                    >
                        <p>{t("requestConfirmationChange")}</p>
                    </ConfirmationModal>
                ):""}
                {dataDuplicate? (
                    <Modal
                        id="regular-modal" 
                        onClose={() => {setDataDuplicate(false)}}
                        show={dataDuplicate}
                        title={t("requestConfirmation")}
                        footer={(
                            <div className="vn-button-group--responsive">
                              <Button onClick={() => setDataDuplicate(false)} >Ok</Button>
                            </div>
                          )}
                    >
                        <Scrollbar>
                            <div style={{ maxHeight: "100px" }}>
                                {dataContent}
                            </div>
                        </Scrollbar>
                    </Modal>
                ):""}
                {submit? (
                    <AlertModal
                        id="alert-modal"
                        onClose={() => setSubmit(false)}
                        show={submit}
                        title={t("upload")}
                    >
                        <Button
                            expanded={true}
                            loading
                            appearance="tertiary"
                        />
                    </AlertModal>
                ):("")}
                <Row>
                    <Col 
                        style={{
                            position: "absolute",
                            marginTop: "15px",
                        }}
                    >
                        <div 
                            style={{
                                marginLeft: "30%",
                                width: "250px",
                            }}
                        >
                            <FilePicker 
                                id="Files"
                                accept=".xlsx,.xls,.csv"
                                onChange={handleChange}
                                disabled={channel}
                            />
                            <Button 
                                style={{
                                    position: "absolute",
                                    height: "35px",
                                    width: "50px",
                                    marginLeft: "252px",
                                    marginTop: "-35px"
                                }}
                                leadingIcon={<IconPlus size={30} filled />}
                                onClick={() => submitFile("initial")}
                                disabled={channel?true:file?false:true}
                            />
                            <Button 
                                style={{
                                    marginTop: "8px",
                                }}
                                appearance="secondary" 
                                leadingIcon={<IconDownload />} 
                                onClick={() => {downloadFile("VolumeAccelerationListTemplate.xlsx");}}
                                disabled={channel?true:file?true:false}
                            >
                                {t('downloadTemplate')}
                            </Button>
                            {showNotification ? (
                                <div className="show-animated" >
                                    <InlineNotification
                                        title={notificationDetails.title}
                                        type={notificationDetails.type}
                                        description={notificationDetails.description}
                                        onClose={() => { setShowNotification(false) }}
                                    /> <br />
                                </div>
                            ) : undefined}
                        </div>
                    </Col>
                </Row>
                <div style={{marginTop: "105px", width: "300px", marginLeft:"30%"}}> <br /><br />
                    <label>{t('channel')}</label>
                    <Select
                        options={channelView}
                        value={channel}
                        placeholder={t('select_channel')}
                        onChange={(e) => {setChannel([e.value]);fetchEndUsers(e.value);}}
                        onClear={() => {setChannel(undefined);setIdEndUser(undefined);setEndUserList([]);}}
                        disabled={file?true:false}
                    /> <br />
                    <label>{t('endUserName')}</label>
                    <Select
                        options={endUserList}
                        value={idEndUser}
                        placeholder={t('endUserName')}
                        onChange={(e) => {setIdEndUser([e.value]);}}
                        onClear={() => setIdEndUser(undefined)}
                        disabled={channel?false:true}
                    /> <br />
                    <label> {t("targetTPI")} </label>
                    <TextBox
                        type='number'
                        step='1'
                        placeholder="0"
                        value={targetTPI}
                        onChange={(value) => { setTargetTPI(value) }}
                        disabled={idEndUser?false:true}
                    /> <br />
                    <label> {t("addBonus")} </label>
                    <TextBox
                        type='number'
                        step='0.01'
                        placeholder="0.00"
                        value={addBonus}
                        onChange={(value) => { setAddBonus(value) }}
                        disabled={idEndUser?(targetTPI?false:true):true}
                    /> <br />
                    <label> {t("addCreditNote")} </label>
                    <TextBox
                        type='number'
                        step='0.01'
                        placeholder="0.00"
                        value={addCreditNote}
                        onChange={(value) => { setAddCreditNote(value) }}
                        disabled={idEndUser?(targetTPI?(addBonus?false:true):true):true}
                    /> <br />
                    <DatePicker
                        calendarOrientation={['up']}
                        enableOutsideDays
                        endDate={endDate}
                        endDateLabel={t("specialcondition.enddate")}
                        endDatePlaceholder="yyyy/mm/dd"
                        onChange={handleOnDateChange}
                        range
                        startDate={startDate}
                        startDateLabel={t("specialcondition.startdate")}
                        startDatePlaceholder="yyyy/mm/dd"
                        disabled={idEndUser?(targetTPI?(addBonus?(addCreditNote?false:true):true):true):true}
                    /> <br />
                    {showNotification ? (
                        <div className="show-animated" style={{ marginBottom: '-12px' }}>
                            <InlineNotification
                                title={notificationDetails.title}
                                type={notificationDetails.type}
                                description={notificationDetails.description}
                                onClose={() => { setShowNotification(false) }}
                            /> <br />
                        </div>
                    ) : undefined}
                    <Button
                        appearance="success"
                        disabled={idEndUser?buttonFlag:true}
                        onClick={validFormData}
                    > {t("addNewValue")} </Button>
                </div>
            </div>
        );
    }

    let list = [
        { id: 0, label: t('VolumeAcceleration'), content: <div><RenderVolumeAcceleration/></div>},
        { id: 1, label: t('ResultVA'), content: <div><RenderResultVA/></div>},
        { id: 2, label: t("Data Upload"), content: <div><AddVolumAcelerationOptions/></div>}
    ];

    return (<>
        <Tabs
            controlId="default"
            onChangeTab={selectTab()}
            selectedTabId={activeTabIndex}
            tabs={list}
        />
    </>);
}

export default VolumeAcceleration;